import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
//#region src/lib/utils.ts
function n(...n) {
	return t(e(n));
}
var r = (e) => {
	let t = new Date(e), n = {
		month: "long",
		day: "numeric",
		timeZone: "UTC",
		...t.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && { year: "numeric" }
	};
	return t.toLocaleDateString("en-US", n);
}, i = (e, t) => {
	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
	for (let n in e) if (typeof e[n] == "object" && e[n] !== null) {
		let r = i(e[n], t);
		if (r !== void 0) return r;
	}
};
//#endregion
export { n as cn, i as findValueByKey, r as formatDateWithYear };
